import React from "react";

import {Button} from "@/components/buttons";
import {InputLabel} from "@/components/inputs";
import {ButtonProps, PropsInput} from "@/components/props";
import {INewPassword} from "@/types/auth";
import {NewPassword} from "@/models/auth";
import {useEnterKeydown, useFormikConfig, useSubmitting} from "@/pages/login/hooks";
import {observer} from "mobx-react-lite";
import {onSubmitSetPassword} from "@/pages/login/submits";
import {useStore} from "@/store";


export const FormPassword = observer(() => {
    const [isFocus, setIsFocus] = React.useState<boolean>(false);
    const {formActiveStore: {setFormActive}} = useStore()
    const onSubmit = () => onSubmitSetPassword(formik, setFormActive);
    const initialValues: INewPassword = new NewPassword();
    const validationSchema = (initialValues as NewPassword).validationSchema();
    const formik = useFormikConfig<INewPassword>(initialValues, onSubmit, validationSchema);
    useSubmitting(formik);
    useEnterKeydown(isFocus, onSubmit, setIsFocus);

    //Элементы формы

    const password1Props: PropsInput = {
        type: 'password',
        name: 'password1',
        label: 'Пароль',
        error: formik.touched.password1 && formik.errors.password1 || '',
        placeholder: 'Введите новый пароль',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.password1,
        autoComplete: 'off',
    }
    const password2Props: PropsInput = {
        type: 'password',
        name: 'password2',
        label: 'Проверка пароля',
        error: formik.touched.password1 && formik.errors.password1,
        placeholder: 'Введите пароль еще раз',
        colorError: 'red',
        onChange: formik.handleChange,
        onBlur: formik.handleBlur,
        value: formik.values.password2,
        autoComplete: 'off',
        onFocus: () => setIsFocus(true)
    }
    const buttonProps: ButtonProps = {
        disabled: !formik.isValid || formik.isSubmitting,
        type: 'submit'

    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <InputLabel {...password1Props}/>
            <InputLabel {...password2Props}/>
            <Button {...buttonProps}>Установить пароль</Button>
        </form>
    )
});

export default FormPassword;